function verifyAge(){   
  var params = $('#verify-age-form').serialize();

  $.ajax({
    url: "https://jsavinvoices.com/ve/age-verification.php",
    method: "GET",
    data: params,
  }).done(function(xml) {
    //console.log(xml);
    var verify = $(xml).find('WorkflowOutcome').text();
    var name = $(xml).find('FirstName').first().text() + ' ' + $(xml).find('LastName').first().text();
    var address = $(xml).find('Street').first().text() + ', ' + $(xml).find('City').first().text() + ', ' + $(xml).find('State').first().text() + ', ' + $(xml).find('ZipCode').first().text();

    //Adds name and address to pass/fail message from retrieved xml
    $('.name').html(name);
    $('.address').html(address);

    //Removes verify button, hides the form, and shows pass/fail information
    if(verify == 'Pass'){
      $('#checkout').attr('name', 'checkout');
      $('#verify').remove();
      $('#cartAgeVerification').hide();
      $('#cartAgeVerificationPass').show();
    }else if(verify == 'Fail'){
      $('#verify').remove();
      $('#cartAgeVerification').hide();
      $('#cartAgeVerificationFail').show();  
    }else if(verify == 'Needs Further Review'){
      $('#cartAgeVerificationNeedFurtherReview').show();
      $('#cartAgeVerificationNeedFurtherReview').animate({backgroundColor:"#FFC3C3"},250);
      $('#cartAgeVerificationNeedFurtherReview').animate({backgroundColor:"#fff"},250);
    }else{
      $('#verify').remove();
      $('#cartAgeVerification').hide();
      $('#cartAgeVerificationDown').show();
      $('#cartAgeVerificationDown').animate({backgroundColor:"#FFC3C3"},250);
      $('#cartAgeVerificationDown').animate({backgroundColor:"#fff"},250);
    }

  }).fail(function() {
     
    $('#verify').remove();
    $('#cartAgeVerification').hide();
    $('#cartAgeVerificationDown').show();
    $('#cartAgeVerificationDown').animate({backgroundColor:"#FFC3C3"},250);
    $('#cartAgeVerificationDown').animate({backgroundColor:"#fff"},250);
    
  });  
}
